import { decodeOneOf, encodeOneOf, safeId } from '../../../../domain';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'cu';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /**
     * A aba da area de usuarios da empresa, e a empresa que o super admin escolheu.
     *
     * `i` era o codigo da data de referencia do painel, liberado quando o periodo
     * virou intervalo. Reusar um codigo morto e melhor que ficar sem nenhum: os de um
     * caractere acabaram aqui.
     */
    CompanyTab: `${PREFIX}a`,
    /**
     * PRIMEIRO codigo de dois caracteres do sistema, e nao por descuido: os de um
     * acabaram. O `url-codes.test.ts` sempre permitiu ate dois; o que ele cobra e
     * unicidade e brevidade, e nao um tamanho fixo.
     */
    CompanyUsersCompany: `${PREFIX}b`
};
/** Os atributos deste place: viajam na intencao, mas nao vao para o endereco. */
const A = {
    /** O presenter da area de usuarios da empresa, pela mesma razao. */
    companyUsers_owner: `${PREFIX}c`
};
/**
 * O codigo de cada aba no endereco.
 *
 * A aba de USUARIOS e o padrao e por isso nao aparece na URL - so a solicitacao
 * precisa ser dita. Ver a nota sobre onde uma tabela de codigo mora, em
 * `domain/index.ts`: esta fica aqui porque o vocabulario e desta tela.
 */
export const COMPANY_TAB_CODES = {
    '0': 'usuarios',
    '1': 'solicitacoes'
};
export class CompanyUsersKeys extends RestrictedKeys {
    get place() {
        return Places.companyUsers;
    }
    get tab() {
        return decodeOneOf(this._intent.getParameterAsString(P.CompanyTab), COMPANY_TAB_CODES, 'usuarios');
    }
    set tab(value) {
        this._intent.setParameter(P.CompanyTab, value === 'usuarios' ? undefined : encodeOneOf(value, COMPANY_TAB_CODES));
    }
    /**
     * A empresa que se esta administrando.
     *
     * So o administrador GERAL a escolhe; o de empresa administra a dele, e o
     * servidor ignora o parametro nesse caso. Por isso ela mora no endereco: e a
     * unica coisa que distingue duas telas do super admin.
     */
    get companyId() {
        return safeId(this._intent.getParameterAsNumber(P.CompanyUsersCompany));
    }
    set companyId(value) {
        this._intent.setParameter(P.CompanyUsersCompany, value);
    }
    // :: area
    /**
     * O presenter da area, para os dialogos pedirem recarga a ele.
     *
     * Chamado `area` e nao `owner` porque `RestrictedKeys.owner` ja existe e e o
     * HUB - mesma razao do `list` em `CompaniesKeys`. Atributo, entao nunca chega
     * a URL.
     */
    get area() {
        return this._intent.attributes.get(A.companyUsers_owner);
    }
    set area(value) {
        this._intent.attributes.set(A.companyUsers_owner, value);
    }
}
//# sourceMappingURL=company-users.key.js.map